export default __webpack_public_path__ + "static/media/ufo.94f24460.png";